import { useRequiredContext } from "@redotech/react-util/context";
import { TrackingPageTextBlock } from "@redotech/redo-model/order-tracking/tracking-page-definition";
import htmlReactParser from "html-react-parser";
import { memo } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";
import { TrackingPageContext } from "../context/tracking-page-context";

export const TextBlock = memo(function TextBlock(props: TrackingPageTextBlock) {
  const { pageSettings } = useRequiredContext(TrackingPageContext);

  const hasContent = props.html.trim().length > 0;
  const containerId = `text-block-${props._id}`;
  const linkColor = pageSettings?.typography.linkFontColor ?? "#2563eb";

  return (
    <>
      <style>
        {`#${containerId} a {
          color: ${linkColor};
          text-decoration: underline;
        }`}
      </style>
      <Flex
        dir="column"
        height="full"
        id={containerId}
        style={{
          backgroundColor: pageSettings?.blockSettings.backgroundColor,
          borderRadius: pageSettings?.blockSettings.borderRadius,
          fontFamily: pageSettings?.typography.bodyFontFamily,
          color: pageSettings?.typography.bodyFontColor,
          fontSize: props.fontSize,
          lineHeight: props.lineHeight,
          padding: props.padding,
          overflow: "auto",
        }}
      >
        {hasContent ? (
          htmlReactParser(props.html)
        ) : (
          <Text fontSize="sm" textColor="tertiary">
            Text
          </Text>
        )}
      </Flex>
    </>
  );
});
